import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  es: {
    "nav.explore": "Explorar",
    "nav.categories": "Categorías",
    "nav.sell": "Vender",
    "nav.dashboard": "Dashboard",
    "nav.purchases": "Mis compras",
    "nav.help": "Ayuda",
    "nav.login": "Iniciar sesión",
    "nav.register": "Crear cuenta",
    "nav.logout": "Cerrar sesión",
    "nav.becomeSeller": "Conviértete en vendedor",
    "home.badge": "Marketplace impulsado por IA",
    "home.title": "Productos digitales listos para usar, encontrados al instante",
    "home.subtitle": "Descubre plantillas, kits de UI, ebooks, código y más — creado por freelancers de todo el mundo.",
    "home.searchPlaceholder": "Describe lo que necesitas... ej: 'un kit de UI moderno para un dashboard'",
    "home.searchBtn": "Buscar con IA",
    "home.trending": "Tendencia ahora",
    "home.newArrivals": "Novedades",
    "product.bestSeller": "Más vendido",
    "home.forYou": "Recomendado para ti",
    "home.byCategory": "Explora por categoría",
    "home.aiHint": "Búsqueda inteligente por intención",
    "home.ctaSellTitle": "¿Creas productos digitales?",
    "home.ctaSellText": "Publica en minutos con ayuda de IA y llega a compradores de todo el mundo.",
    "home.ctaSellBtn": "Empieza a vender",
    "explore.title": "Explorar productos",
    "explore.results": "resultados",
    "explore.sort": "Ordenar",
    "explore.sort.recent": "Más recientes",
    "explore.sort.popular": "Más populares",
    "explore.sort.price_low": "Precio: menor a mayor",
    "explore.sort.price_high": "Precio: mayor a menor",
    "explore.sort.rating": "Mejor valorados",
    "explore.allCategories": "Todas las categorías",
    "explore.empty": "No se encontraron productos.",
    "product.buy": "Comprar ahora",
    "product.owned": "Ya lo tienes — Descargar",
    "product.download": "Descargar",
    "product.by": "Por",
    "product.whatsIncluded": "Qué incluye",
    "product.related": "Productos relacionados",
    "product.aiRelated": "Seleccionados para ti",
    "product.sales": "ventas",
    "product.instant": "Descarga instantánea tras la compra",
    "product.secure": "Pago seguro con Stripe",
    "auth.loginTitle": "Bienvenido de vuelta",
    "auth.registerTitle": "Crea tu cuenta en Fedeys",
    "auth.name": "Nombre",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.role": "Quiero...",
    "auth.roleBuyer": "Comprar productos",
    "auth.roleSeller": "Vender productos",
    "auth.loginBtn": "Iniciar sesión",
    "auth.registerBtn": "Crear cuenta",
    "auth.noAccount": "¿No tienes cuenta?",
    "auth.hasAccount": "¿Ya tienes cuenta?",
    "auth.demoHint": "Prueba: buyer@fedeys.com / buyer123 · seller@fedeys.com / seller123",
    "dash.title": "Dashboard del vendedor",
    "dash.products": "Productos",
    "dash.sales": "Ventas",
    "dash.revenue": "Ingresos",
    "dash.views": "Vistas",
    "dash.newProduct": "Nuevo producto",
    "dash.myProducts": "Mis productos",
    "dash.recentOrders": "Ventas recientes",
    "dash.topProducts": "Productos destacados",
    "dash.noOrders": "Aún no tienes ventas.",
    "dash.edit": "Editar",
    "dash.delete": "Eliminar",
    "form.createTitle": "Publicar producto",
    "form.editTitle": "Editar producto",
    "form.notes": "Notas para la IA",
    "form.notesPlaceholder": "Describe tu producto en pocas palabras y deja que la IA cree el listado...",
    "form.generate": "Generar con IA",
    "form.generating": "Generando...",
    "form.pTitle": "Título",
    "form.pDescription": "Descripción",
    "form.pBullets": "Puntos de venta (uno por línea)",
    "form.pPrice": "Precio (USD)",
    "form.pCategory": "Categoría",
    "form.pTags": "Tags (separados por coma)",
    "form.pImage": "Imagen de portada",
    "form.pFile": "Archivo digital",
    "form.pGallery": "Galería / vista previa (varias imágenes)",
    "form.uploadImage": "Subir imagen",
    "form.uploadFile": "Subir archivo",
    "form.publish": "Publicar",
    "form.save": "Guardar cambios",
    "form.aiSuggested": "Sugerido por IA",
    "purchases.title": "Mis compras",
    "purchases.empty": "Todavía no has comprado nada.",
    "purchases.explore": "Explorar productos",
    "pay.processing": "Procesando tu pago...",
    "pay.success": "¡Pago completado!",
    "pay.successText": "Gracias por tu compra. Ya puedes descargar tu archivo.",
    "pay.goPurchases": "Ir a mis compras",
    "pay.cancelled": "Pago cancelado",
    "pay.cancelledText": "No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.",
    "pay.backHome": "Volver al inicio",
    "help.title": "Centro de ayuda",
    "seller.since": "Miembro desde",
    "seller.products": "productos",
    "seller.sales": "ventas",
    "common.loading": "Cargando...",
    "common.free": "Gratis",
    "review.title": "Reseñas",
    "review.write": "Escribe una reseña",
    "review.yourRating": "Tu valoración",
    "review.comment": "Comentario",
    "review.submit": "Publicar reseña",
    "review.empty": "Aún no hay reseñas. ¡Sé el primero en opinar!",
    "review.onlyBuyers": "Solo quienes compraron el producto pueden dejar una reseña.",
    "review.thanks": "¡Gracias por tu reseña!",
    "coupon.have": "¿Tienes un cupón?",
    "coupon.placeholder": "Código del cupón",
    "coupon.apply": "Aplicar",
    "coupon.applied": "Cupón aplicado",
    "coupon.invalid": "Cupón inválido o expirado",
    "coupon.remove": "Quitar",
    "dash.coupons": "Cupones",
    "dash.newCoupon": "Nuevo cupón",
    "dash.couponCode": "Código",
    "dash.couponType": "Tipo",
    "dash.couponPercent": "Porcentaje (%)",
    "dash.couponFixed": "Monto fijo ($)",
    "dash.couponValue": "Valor",
    "dash.couponProduct": "Producto (opcional)",
    "dash.couponAllProducts": "Todos mis productos",
    "dash.couponMaxUses": "Usos máx. (opcional)",
    "dash.couponCreate": "Crear cupón",
    "dash.couponUses": "usos",
    "dash.noCoupons": "Aún no tienes cupones.",
    "nav.favorites": "Favoritos",
    "fav.title": "Mis favoritos",
    "fav.empty": "Aún no has guardado ningún producto.",
    "fav.explore": "Explorar productos",
    "seller.verified": "Vendedor verificado",
    "home.featuredSellers": "Vendedores verificados destacados",
    "notif.title": "Notificaciones",
    "notif.empty": "No tienes notificaciones todavía.",
    "notif.markRead": "Marcar todo como leído",
    "notif.couponIn": "Cupón en un favorito",
    "notif.by": "por",
    "nav.admin": "Admin",
    "admin.title": "Panel de administración",
    "admin.users": "Usuarios",
    "admin.sellers": "Vendedores",
    "admin.products": "Productos",
    "admin.hidden": "Ocultos",
    "admin.orders": "Ventas",
    "admin.revenue": "Ingresos",
    "admin.search": "Buscar producto...",
    "admin.all": "Todos",
    "admin.published": "Publicados",
    "admin.statusHidden": "Ocultos",
    "admin.hide": "Ocultar",
    "admin.publish": "Publicar",
    "admin.delete": "Eliminar",
    "admin.confirmDelete": "¿Eliminar este producto de forma permanente?",
    "admin.empty": "No hay productos.",
    "admin.badgeHidden": "Oculto",
    "admin.tabProducts": "Productos",
    "admin.tabUsers": "Usuarios",
    "admin.pending": "Pendientes",
    "admin.statusPending": "Pendientes",
    "admin.approve": "Aprobar",
    "admin.name": "Nombre",
    "admin.email": "Correo",
    "admin.role": "Rol",
    "admin.suspend": "Suspender",
    "admin.unsuspend": "Reactivar",
    "admin.suspended": "Suspendido",
    "admin.usersEmpty": "No hay usuarios.",
    "explore.verifiedOnly": "Solo verificados",
    "product.share": "Compartir",
    "product.linkCopied": "¡Enlace copiado!",
    "dash.status": "Estado",
    "dash.statusPending": "En revisión",
    "dash.statusPublished": "Publicado",
    "dash.statusHiddenLabel": "Oculto",
    "dash.pendingNote": "Tus productos nuevos se revisan antes de publicarse.",
    "form.pendingMsg": "¡Enviado a revisión! Se publicará tras la aprobación.",
  },
  en: {
    "nav.explore": "Explore",
    "nav.categories": "Categories",
    "nav.sell": "Sell",
    "nav.dashboard": "Dashboard",
    "nav.purchases": "My purchases",
    "nav.help": "Help",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "nav.becomeSeller": "Become a seller",
    "home.badge": "AI-powered marketplace",
    "home.title": "Ready-to-use digital products, found instantly",
    "home.subtitle": "Discover templates, UI kits, ebooks, code and more — crafted by freelancers worldwide.",
    "home.searchPlaceholder": "Describe what you need... e.g. 'a modern UI kit for a dashboard'",
    "home.searchBtn": "Search with AI",
    "home.trending": "Trending now",
    "home.newArrivals": "New arrivals",
    "product.bestSeller": "Best seller",
    "home.forYou": "Recommended for you",
    "home.byCategory": "Browse by category",
    "home.aiHint": "Intent-based smart search",
    "home.ctaSellTitle": "Do you create digital products?",
    "home.ctaSellText": "Publish in minutes with AI help and reach buyers worldwide.",
    "home.ctaSellBtn": "Start selling",
    "explore.title": "Explore products",
    "explore.results": "results",
    "explore.sort": "Sort",
    "explore.sort.recent": "Newest",
    "explore.sort.popular": "Most popular",
    "explore.sort.price_low": "Price: low to high",
    "explore.sort.price_high": "Price: high to low",
    "explore.sort.rating": "Top rated",
    "explore.allCategories": "All categories",
    "explore.empty": "No products found.",
    "product.buy": "Buy now",
    "product.owned": "You own this — Download",
    "product.download": "Download",
    "product.by": "By",
    "product.whatsIncluded": "What's included",
    "product.related": "Related products",
    "product.aiRelated": "Picked for you",
    "product.sales": "sales",
    "product.instant": "Instant download after purchase",
    "product.secure": "Secure payment with Stripe",
    "auth.loginTitle": "Welcome back",
    "auth.registerTitle": "Create your Fedeys account",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.role": "I want to...",
    "auth.roleBuyer": "Buy products",
    "auth.roleSeller": "Sell products",
    "auth.loginBtn": "Log in",
    "auth.registerBtn": "Sign up",
    "auth.noAccount": "Don't have an account?",
    "auth.hasAccount": "Already have an account?",
    "auth.demoHint": "Try: buyer@fedeys.com / buyer123 · seller@fedeys.com / seller123",
    "dash.title": "Seller dashboard",
    "dash.products": "Products",
    "dash.sales": "Sales",
    "dash.revenue": "Revenue",
    "dash.views": "Views",
    "dash.newProduct": "New product",
    "dash.myProducts": "My products",
    "dash.recentOrders": "Recent sales",
    "dash.topProducts": "Top products",
    "dash.noOrders": "No sales yet.",
    "dash.edit": "Edit",
    "dash.delete": "Delete",
    "form.createTitle": "Publish product",
    "form.editTitle": "Edit product",
    "form.notes": "Notes for the AI",
    "form.notesPlaceholder": "Describe your product briefly and let AI craft the listing...",
    "form.generate": "Generate with AI",
    "form.generating": "Generating...",
    "form.pTitle": "Title",
    "form.pDescription": "Description",
    "form.pBullets": "Selling points (one per line)",
    "form.pPrice": "Price (USD)",
    "form.pCategory": "Category",
    "form.pTags": "Tags (comma separated)",
    "form.pImage": "Cover image",
    "form.pFile": "Digital file",
    "form.pGallery": "Gallery / preview (multiple images)",
    "form.uploadImage": "Upload image",
    "form.uploadFile": "Upload file",
    "form.publish": "Publish",
    "form.save": "Save changes",
    "form.aiSuggested": "AI suggested",
    "purchases.title": "My purchases",
    "purchases.empty": "You haven't bought anything yet.",
    "purchases.explore": "Explore products",
    "pay.processing": "Processing your payment...",
    "pay.success": "Payment complete!",
    "pay.successText": "Thanks for your purchase. You can now download your file.",
    "pay.goPurchases": "Go to my purchases",
    "pay.cancelled": "Payment cancelled",
    "pay.cancelledText": "No charge was made. You can try again anytime.",
    "pay.backHome": "Back home",
    "help.title": "Help center",
    "seller.since": "Member since",
    "seller.products": "products",
    "seller.sales": "sales",
    "common.loading": "Loading...",
    "common.free": "Free",
    "review.title": "Reviews",
    "review.write": "Write a review",
    "review.yourRating": "Your rating",
    "review.comment": "Comment",
    "review.submit": "Post review",
    "review.empty": "No reviews yet. Be the first to share your thoughts!",
    "review.onlyBuyers": "Only buyers who purchased this product can leave a review.",
    "review.thanks": "Thanks for your review!",
    "coupon.have": "Have a coupon?",
    "coupon.placeholder": "Coupon code",
    "coupon.apply": "Apply",
    "coupon.applied": "Coupon applied",
    "coupon.invalid": "Invalid or expired coupon",
    "coupon.remove": "Remove",
    "dash.coupons": "Coupons",
    "dash.newCoupon": "New coupon",
    "dash.couponCode": "Code",
    "dash.couponType": "Type",
    "dash.couponPercent": "Percentage (%)",
    "dash.couponFixed": "Fixed amount ($)",
    "dash.couponValue": "Value",
    "dash.couponProduct": "Product (optional)",
    "dash.couponAllProducts": "All my products",
    "dash.couponMaxUses": "Max uses (optional)",
    "dash.couponCreate": "Create coupon",
    "dash.couponUses": "uses",
    "dash.noCoupons": "You don't have any coupons yet.",
    "nav.favorites": "Favorites",
    "fav.title": "My favorites",
    "fav.empty": "You haven't saved any products yet.",
    "fav.explore": "Explore products",
    "seller.verified": "Verified seller",
    "home.featuredSellers": "Featured verified sellers",
    "notif.title": "Notifications",
    "notif.empty": "You have no notifications yet.",
    "notif.markRead": "Mark all as read",
    "notif.couponIn": "Coupon on a favorite",
    "notif.by": "by",
    "nav.admin": "Admin",
    "admin.title": "Admin panel",
    "admin.users": "Users",
    "admin.sellers": "Sellers",
    "admin.products": "Products",
    "admin.hidden": "Hidden",
    "admin.orders": "Sales",
    "admin.revenue": "Revenue",
    "admin.search": "Search product...",
    "admin.all": "All",
    "admin.published": "Published",
    "admin.statusHidden": "Hidden",
    "admin.hide": "Hide",
    "admin.publish": "Publish",
    "admin.delete": "Delete",
    "admin.confirmDelete": "Permanently delete this product?",
    "admin.empty": "No products.",
    "admin.badgeHidden": "Hidden",
    "admin.tabProducts": "Products",
    "admin.tabUsers": "Users",
    "admin.pending": "Pending",
    "admin.statusPending": "Pending",
    "admin.approve": "Approve",
    "admin.name": "Name",
    "admin.email": "Email",
    "admin.role": "Role",
    "admin.suspend": "Suspend",
    "admin.unsuspend": "Reactivate",
    "admin.suspended": "Suspended",
    "admin.usersEmpty": "No users.",
    "explore.verifiedOnly": "Verified only",
    "product.share": "Share",
    "product.linkCopied": "Link copied!",
    "dash.status": "Status",
    "dash.statusPending": "Under review",
    "dash.statusPublished": "Published",
    "dash.statusHiddenLabel": "Hidden",
    "dash.pendingNote": "New products are reviewed before going live.",
    "form.pendingMsg": "Submitted for review! It will go live after approval.",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("fedeys_lang") || "es");
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "es" ? "en" : "es";
      localStorage.setItem("fedeys_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || key, [lang]);
  return <I18nContext.Provider value={{ lang, t, toggle }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export function catName(cat, lang) {
  if (!cat) return "";
  return lang === "es" ? cat.name_es : cat.name_en;
}
